export const srcSetWidths = [565, 610, 750, 800, 1200, 1920, 2880];

export const generateSrcSet = (src: string, loader: any, sizes = srcSetWidths) => {
  const srcSet = sizes.map(size => `${loader({ src, width: size })} ${size}w`);
  return srcSet.join(', ');
};
